export default __webpack_public_path__ + "static/media/Gulmarg4.6359cc31.jpg";